import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = {
  key: 0,
  class: "close"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 24 24" }, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
  })
], -1 /* HOISTED */)
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" NOTE: this must be the same HTML as in the Frontend server-alert-preview.html code"),
    _createCommentVNode(" NOTE: the root element (commented below) is managed by the module when it creates this wrapping div"),
    _createCommentVNode(" <div class=\"stm-alert-wrapper hidden\" :id=\"info.id\"> "),
    _createElementVNode("div", {
      ref: "alert",
      class: "server-alert",
      style: _normalizeStyle({ background: $props.info.backgroundColor })
    }, [
      _createElementVNode("span", {
        class: "alert-content",
        innerHTML: $props.info.contentHtml
      }, null, 8 /* PROPS */, _hoisted_1),
      (!!$props.info.dismissableForHours && $props.info.dismissableForHours > 0)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _hoisted_4))
        : _createCommentVNode("v-if", true)
    ], 4 /* STYLE */),
    _createCommentVNode(" </div> ")
  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
}